// Offline-publish retry queue (README "Prochaines étapes": "file d'attente
// hors-ligne de publication, republier à la reconnexion").
//
// Saving a profile edit is local and always succeeds; sharing it with friends
// needs the relay. When that publish fails (offline, relay unreachable), the
// edit itself isn't lost — it's already on disk — but without this flag it
// would only reach friends on the *next* edit, silently. This is the memory
// of "friends don't have my latest yet": set when a publish attempt fails,
// cleared once one actually reaches the relay, checked by the sync manager on
// every reconnect/focus/heartbeat so it retries without the user doing anything.

import { idbGet, idbPut, STORE_IDENTITY } from './db';
import { setSyncState } from './syncState';

const PENDING_PUBLISH_KEY = 'pendingPublish';

export async function isPublishPending(): Promise<boolean> {
  return (await idbGet<boolean>(STORE_IDENTITY, PENDING_PUBLISH_KEY)) === true;
}

export async function markPublishPending(): Promise<void> {
  await idbPut(STORE_IDENTITY, PENDING_PUBLISH_KEY, true);
  setSyncState({ pendingPublish: true });
}

export async function clearPublishPending(): Promise<void> {
  await idbPut(STORE_IDENTITY, PENDING_PUBLISH_KEY, false);
  setSyncState({ pendingPublish: false });
}
